<div class="modal-header">
  <h3 class="modal-title">
    {{ title }}
    <i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
    <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise = !minimise"></i>
  </h3>
</div>

<div class="modal-body" [hidden]="minimise">
  <div style="margin-bottom:8px;">
    <button class="reset-button" type="button" (click)="addRow()">Add Row</button>
  </div>
  <table class="table table-bordered custom-table">
    <thead>
      <tr>
        <th></th>
        <th>Period Name</th>
        <th>Tax Year</th>
        <th>Type</th>
        <th>Gold ID</th>
        <th>Mars ID</th>
        <th>Country</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      @for (row of rows; track $index; let i = $index) {
<tr>
        <td><i class="fa fa-minus-circle" style="cursor:pointer;color:#e74c3c;" (click)="removeRow(i)"></i></td>
        <td><input class="form-control" [ngModel]="row.PERIOD_NAME" (ngModelChange)="row.PERIOD_NAME=$event"></td>
        <td>
          <select class="form-control" [ngModel]="row.TAX_YEAR" (ngModelChange)="row.TAX_YEAR=$event">
            @for (y of tax_years; track $index) {
<option [value]="y">{{ y }}</option>
}
          </select>
        </td>
        <td>
          <select class="form-control" [ngModel]="row.TYPE" (ngModelChange)="row.TYPE=$event">
            @for (t of types; track $index) {
<option [value]="t.VALUE">{{ t.LABEL }}</option>
}
          </select>
        </td>
        <td><input class="form-control" [ngModel]="row.GOLD_ID" (ngModelChange)="row.GOLD_ID=$event"></td>
        <td><input class="form-control" [ngModel]="row.MARS_ID" (ngModelChange)="row.MARS_ID=$event"></td>
        <td><input class="form-control" [ngModel]="row.IMPOSING_TAX_DESC" (ngModelChange)="row.IMPOSING_TAX_DESC=$event"></td>
        <td><input class="form-control" [ngModel]="row.AMOUNT" (ngModelChange)="row.AMOUNT=$event"></td>
      </tr>
}
    </tbody>
  </table>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="crudLoading" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save Batch
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
